/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const dataRemovalRequestDataStatus = {
	pending: 'pending',
	notified: 'notified',
	approved: 'approved',
	rejected: 'rejected',
	completed: 'completed',
	expired: 'expired',
} as const

export type DataRemovalRequestDataStatus =
	(typeof dataRemovalRequestDataStatus)[keyof typeof dataRemovalRequestDataStatus]
